import { addClickOutsideListener } from "./helpers/dialogHelpers";

export class Dialog {
    private dialog: HTMLDialogElement;
    private closeDialogButton: HTMLButtonElement;

    constructor(showDialogButton: HTMLButtonElement) {
        const dialog: HTMLElement = document.getElementById(showDialogButton.getAttribute("data-dialog-id"));
        if (!dialog || !(dialog instanceof HTMLDialogElement)) {
            return;
        }

        this.dialog = dialog;
        this.closeDialogButton = this.dialog.querySelector("button");

        showDialogButton.addEventListener("click", () => {
            this.showDialog();
        });

        this.closeDialogButton.addEventListener("click", () => {
            this.hideDialog();
        });

        addClickOutsideListener(dialog);
    }

    private showDialog = () => {
        this.dialog.showModal();
    };

    private hideDialog = () => {
        this.dialog.close();
    };
}
